var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFrontBar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 11,
    viewBox: "0 0 7 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.16667 11V9.77778H2.91667V7.27222C2.08056 7.12963 1.38542 6.72222 0.83125 6.05C0.277083 5.37778 0 4.58333 0 3.66667V0H7V3.66667C7 4.58333 6.72292 5.37778 6.16875 6.05C5.61458 6.72222 4.91944 7.12963 4.08333 7.27222V9.77778H5.83333V11H1.16667ZM3.5 6.11111C4.04444 6.11111 4.52083 5.93796 4.92917 5.59167C5.3375 5.24537 5.60972 4.80741 5.74583 4.27778H1.25417C1.39028 4.80741 1.6625 5.24537 2.07083 5.59167C2.47917 5.93796 2.95556 6.11111 3.5 6.11111ZM1.16667 3.05556H5.83333V1.22222H1.16667V3.05556Z",
    fill: "#202020"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrontBar);
export default __webpack_public_path__ + "static/media/front-bar.3edc5ffb4470de78de1642ebd977f6a6.svg";
export { ForwardRef as ReactComponent };